import { Link } from 'react-router-dom';
import { ArrowRight, Warehouse, Search } from 'lucide-react';

interface BlogCTAProps {
  type: 'publish' | 'search' | 'generic';
  className?: string;
}

export function BlogCTA({ type, className = '' }: BlogCTAProps) {
  if (type === 'publish') {
    return (
      <div className={`bg-blue-50 border border-blue-100 rounded-2xl p-6 md:p-8 text-center my-8 ${className}`}>
        <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
          <Warehouse className="w-6 h-6" />
        </div>
        <h3 className="text-xl font-bold text-slate-900 mb-2">¿Tienes un trastero vacío?</h3>
        <p className="text-slate-600 mb-6 max-w-lg mx-auto">
          No dejes que coja polvo. Publícalo gratis en EncuentraTrastero y empieza a ganar dinero hoy mismo.
        </p>
        <Link 
          to="/publish" 
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-xl transition-colors shadow-lg shadow-blue-200"
        >
          Publicar Gratis <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    );
  }

  if (type === 'search') {
    return (
      <div className={`bg-slate-900 text-white rounded-2xl p-6 md:p-8 text-center my-8 ${className}`}>
        <div className="w-12 h-12 bg-slate-800 text-blue-400 rounded-full flex items-center justify-center mx-auto mb-4">
          <Search className="w-6 h-6" />
        </div>
        <h3 className="text-xl font-bold mb-2">Encuentra tu espacio ideal</h3>
        <p className="text-slate-300 mb-6 max-w-lg mx-auto">
          Tenemos miles de trasteros verificados esperando por ti. Filtra por precio, tamaño y ubicación.
        </p>
        <Link 
          to="/search" 
          className="inline-flex items-center gap-2 bg-white text-slate-900 hover:bg-slate-100 font-bold py-3 px-8 rounded-xl transition-colors"
        >
          Buscar Trasteros <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    );
  }

  return null;
}
